import {
  LOAN_OFFERS_FETCH_SUCCESS,
} from '../actionTypes';

let initialState = {
  active: [],
}

export default function loanOffers(state = initialState, action) {
  switch(action.type) {
    case LOAN_OFFERS_FETCH_SUCCESS:
      return { ...state, active: action.payload };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/loans/reducers/loanOffers.js